// cores.ts
const colors = {
  castanha: '#6C5A35',
  castanhaEscuro: '#5c4923',
  polpa: '#F3DD77',
  maduro: '#F47A30',
  caju: '#E43A36',
  folha: '#83A250',
  branco: '#EFEFEF',
  cinza: '#E7E7E7',
  cinzaMedio: '#CCCCCC',
  cinzaEscuro: '#B0B0B0',
  preto: '#190303',

  blue: '#5397DF',
  darkBlue: '#2a70bb',      // Cor do fundo azul
  lightBlue: '#B1D7DC',   // Cor do fundo azul claro
  green: '#8BC24A',       // Cor do fundo verde
  yellow: '#F9C846',        // Cor do fundo verde
  darkYellow: '#F9B246',    // Cor do fundo amarelo alaranjado
  orange: '#F78033',      // Cor do fundo laranja
  red: '#DE523D',         // Cor do fundo vermelho
};
export default colors;
